import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CategoryList, TagList } from '../../model/category.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-smxeditor',
  templateUrl: './smxeditor.component.html',
  styleUrls: ['./smxeditor.component.scss']
})
export class SmxeditorComponent implements OnInit, AfterViewInit  {
  categories: CategoryList[] = [];
  selectedTags: TagList[] = [];
  templateName: string = ''; 
  templateId: string = '';
  templateData: any;
  id

  constructor (private category: CategoryService ,
    private route: ActivatedRoute,
    private router :Router,
    public toaster: ToastrService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,

   ){}
  ngAfterViewInit(): void {
   
  }

  ngOnInit(): void {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css';
    link.id = 'tailwind-stylesheet';
    document.head.appendChild(link);
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      if(id!=undefined){
      this.getTemplateById(id);
      }
    });
    this.allCategoryList();
    //this.getTemplateById(this.templateId);
    console.log('categories',this.categories);
  }
 
  ngOnDestroy() {
    // Remove Tailwind stylesheet when leaving the component
    const link = document.getElementById('tailwind-stylesheet');
    if (link) {
      document.head.removeChild(link);
    }
  }
  allCategoryList(){
    this.category.getAllCategory().subscribe((res =>{
      if(res.isSuccess) {
        this.categories= res?.response;
        
      }
    }))
  }
  
  getTagsForCategory(categoryId){
    this.category.getTagsByCategoryId(categoryId).subscribe((res =>{
      if(res.isSuccess) {
        this.selectedTags= res?.response;
      }
      else{
        this.selectedTags=[];
      }
    }))
  }

  getTemplateById(id: string) {
    this.category.getTemplateById(id).subscribe(
      (response: any) => {
        if (response.isSuccess) {
          const template = response.response;
          this.templateId = template.id;
          this.templateName = template.templateName;
          //this.htmlContent = template.htmlContent; // Set the editor content
        } else {
          console.error('Error fetching template:', response.message);
        }
      },
      (error) => {
        console.error('API error:', error);
      }
    );
  }

}
